import {
  Component,
  EventEmitter,
  OnInit,
  Output
} from '@angular/core';
import { BaseDialog } from '@library-shared/base/base-dialog.component';
import { EventBusService } from '@library-shared/services/event-bus/event-bus.service';
import { spTicket_List } from '@models/StoredProcs/spTicket_List';

@Component({
  selector: 'app-violation-information-dialog',
  templateUrl: './violation-information-dialog.component.html',
  styleUrls: ['./violation-information-dialog.component.scss'],
  standalone: false,
})
export class ViolationInformationDialogComponent extends BaseDialog implements OnInit {
  @Output() completed = new EventEmitter<boolean>();
  ticket: spTicket_List;

  get title(): string {
    return `${this.ticket?.violation_code}: ${this.ticket?.violation_code_description}`;
  }

  constructor(public eventBusService: EventBusService) {
    super(eventBusService);
  }

  onShown() {}

  ngOnInit(): void {}

  showDialog(rec: spTicket_List) {
    this.ticket = rec;
    this.showDialogBase();
  }

  onSubmit(e: any): void {
    this.completed.emit(true);
    this.closeDialogBase();
  }

  onCancel(e: any): void {
    this.completed.emit(false);
    this.closeDialogBase();
  }
}
